import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectLexFallbackIntents(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  const fallbackLogs = logs.filter(
    (log) =>
      log.Source === 'Lex' &&
      (log.LogData.Action?.ExecutionResult === 'FallbackIntent' || log.LogData.Content?.includes('FallbackIntent'))
  );

  if (fallbackLogs.length >= 2) {
    const originalIndex = logs.indexOf(fallbackLogs[0]);
    problems.push({
      id: generateId(),
      type: ProblemType.LEX_FALLBACK_INTENT,
      severity: fallbackLogs.length >= 4 ? ProblemSeverity.HIGH : ProblemSeverity.MEDIUM,
      title: 'Multiple Lex Fallback Intents',
      description: `Lex bot triggered fallback intent ${fallbackLogs.length} times, indicating poor intent recognition`,
      timestamp: fallbackLogs[0].AbsoluteTime,
      source: 'IVR_LOG',
      relatedData: { fallbackCount: fallbackLogs.length, logs: fallbackLogs },
      suggestions: [
        'Review and improve bot training data',
        'Add more utterances to existing intents',
        'Check for common customer phrases not being recognized'
      ],
      index: originalIndex >= 0 ? originalIndex : undefined
    });
  }

  return problems;
}
